/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileSSPResponse
 */
export interface ProfileSSPResponse {
    /**
     * 
     * @type {string}
     * @memberof ProfileSSPResponse
     */
    sspId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileSSPResponse
     */
    assessmentIds?: Array<string>;
}

/**
 * Check if a given object implements the ProfileSSPResponse interface.
 */
export function instanceOfProfileSSPResponse(value: object): value is ProfileSSPResponse {
    return true;
}

export function ProfileSSPResponseFromJSON(json: any): ProfileSSPResponse {
    return ProfileSSPResponseFromJSONTyped(json, false);
}

export function ProfileSSPResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileSSPResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sspId': json['sspId'] == null ? undefined : json['sspId'],
        'assessmentIds': json['assessmentIds'] == null ? undefined : json['assessmentIds'],
    };
}

export function ProfileSSPResponseToJSON(json: any): ProfileSSPResponse {
    return ProfileSSPResponseToJSONTyped(json, false);
}

export function ProfileSSPResponseToJSONTyped(value?: ProfileSSPResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sspId': value['sspId'],
        'assessmentIds': value['assessmentIds'],
    };
}

